// Libs
import React from 'react';
import { Tooltip, Icon, Collapse } from 'antd';
import { ColumnProps } from 'antd/lib/table';

// Own Libs
import { Button, Table, Widget } from '@digital/ui';

//Api
import { DemandaComRequisicao } from '@app/api/requisitanteCapex';

//Files

//Utils
import { compareText } from '@app/helpers/comparators';
import { currencyFormat } from '@app/helpers/numbers';
import { mountFormFilterDropDown } from '@app/utils/formFilterDropDown';
import { TipoDemanda } from '@app/api/demanda';

const { Panel } = Collapse;

interface TabelaDemandasProps {
  dataSourceResult: DemandaComRequisicao[];
  widgettitle: string;
  urlDemanda: string;
  aba: string;
}

const TabelaDemandas = ({ dataSourceResult, widgettitle, urlDemanda, aba }: TabelaDemandasProps) => {

  const columns: ColumnProps<any>[] = [
    {
      title: 'Código',
      dataIndex: 'identificadorTexto',
      sorter: (a, b) => compareText(a.identificadorTexto, b.identificadorTexto),
      ...mountFormFilterDropDown('identificadorTexto', 'Pesquisar'),
      // fixed: 'left',
    },
    {
      title: 'Abertura',
      dataIndex: 'dataAberturaDemandaString',
    },
    {
      title: 'Demandante',
      dataIndex: 'demandante',
    },
    {
      title: 'Dir',
      dataIndex: 'diretoria',
    },
    {
      title: 'Área',
      dataIndex: 'area',
    },
    {
      title: 'Depto',
      dataIndex: 'departamento',
    },
    {
      title: 'Tipo',
      dataIndex: 'tipo',
      render: (text, record) => (record.tipo ? TipoDemanda[record.tipo] : ''),
      sorter: (a, b) => compareText((a.tipo ? TipoDemanda[a.tipo] : ''), (b.tipo ? TipoDemanda[b.tipo] : '')),
      filterMultiple: true,
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) => value != "" && value == record.tipo,
      filters: [
        {
          text: 'Nova Contratação',
          value: '1',
        },
        {
          text: 'Aditivo',
          value: '2',
        },
        {
          text: 'Acordo de Fornecimento',
          value: '3',
        },
        {
          text: 'Faturamento Direto',
          value: '4',
        },
        {
          text: 'Aditivo Faturamento Direto',
          value: '5',
        },
      ],
    },
    {
      title: 'Tipo de Serviço',
      dataIndex: 'tipoServico',
      sorter: (a, b) => compareText(a.tipoServico, b.tipoServico),
      ...mountFormFilterDropDown('tipoServico', 'Pesquisar'),
    },
    {
      title: 'Valor Final',
      dataIndex: 'expectativaValorFinal',
      render: (text, record) => currencyFormat(record.expectativaValorFinal),
    },
    {
      title: 'Status',
      dataIndex: 'statusDemandaNome',
      sorter: (a, b) => compareText(a.statusDemandaNome, b.statusDemandaNome),
      ...mountFormFilterDropDown('statusDemandaNome', 'Pesquisar'),
    },
    {
      title: 'Ações',
      render: (index, record) => (
        <Tooltip title="Ir para Demanda">
          <Button
            type="link"
            icon="arrows-circled_up_right_2"
            name="irparaBm"
            onClick={() => {
              const urlBase = window.location.origin;
              window.open(urlBase + `${urlDemanda}${record.id}${aba}`);
            }}
            href="#"
          />
        </Tooltip>
      ),
      width: '1%',
      // fixed: 'right',
    },
  ];

  return (
    <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />} defaultActiveKey={[widgettitle]}>
      <Panel key={widgettitle} header={widgettitle} style={{ border: 0 }}>
        <Widget>
          <Table columns={columns} dataSource={dataSourceResult} />
        </Widget>
      </Panel>
    </Collapse>
  );
};
export default TabelaDemandas;
